const switchCountry = (TARGET) => {
    const TAB_CLASS = TARGET.dataset.tab;
    if (!TAB_CLASS) {
        return;
    }
    document.querySelectorAll('.js-switch-country-name').forEach((el) => {
        el.classList.remove('active');
    });
    document.querySelectorAll('.js-switch-country').forEach((el) => {
        el.classList.remove('active');
    });
    TARGET.classList.add('active');
    document.querySelectorAll(`.${TAB_CLASS}`).forEach((el) => {
        el.classList.add('active');
    });
};
export default switchCountry;
